<form id="date_filter_form" [formGroup]="form.dateRangeForm">
  <div class="filter-date">
    <!-- <p>{{ filterCaption$ | async }}</p> -->
    <p>{{ labels.title }}</p>

    <div class="date-pickers">
      <mat-form-field appearance="fill" class="date-picker">
        <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
          <input
            matStartDate
            formControlName="start"
            [placeholder]="labels.start"
          />
          <input matEndDate formControlName="end" [placeholder]="labels.end" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button
        type="button"
        class="btn-date-change"
        (click)="onClick()"
        [disabled]="form.isInvalid()"
      >
        {{ labels.search }}
      </button>
    </div>

    @if (isInvalidSearchPeriod()) {
      <span class="date-alert">{{ labels.alertMessage }}</span>
    }
  </div>
</form>
